// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import AboutContent from '../../components/AboutContent';
import { TechnicalInfoContent } from '../../components/TechnicalInfoContent';

// If you do not want to display About entry in help menu, set About to null
export const About = AboutContent;

// If you do not want to display Technical Information entry in help menu, set TechnicalInfoContent to null
export const TechnicalInfo = TechnicalInfoContent;
